import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import index from './modules/index'
// import permission from './modules/permission'
import state from './defaultState'
import modules from "./modules";
import mutations from "./mutations";
import getters from './getters';

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  getters,
  modules:{
    user
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js